import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AudioPlayerService } from '../../services/audio-player.service';
import { AuthService } from '../../services/auth.service';
import { GameService } from '../../services/game.service';

@Component({
  selector: 'app-diploma',
  templateUrl: './diploma.component.html',
  styleUrls: ['./diploma.component.less']
})
export class DiplomaComponent implements OnInit {
  @Input() showEndScreen!: boolean;
  @Output() closeEndScreen = new EventEmitter();

  public svgDiploma = '/img/popup/diploma.svg';
  @ViewChild('emailForm') emailForm!: ElementRef<HTMLFormElement>;
  state: 'input' | 'sending' = 'input';
  diplomaLoadedHandler = this.diplomaLoaded.bind(this);
  public diplomaEmail: string = '';
  public username: string = '';

  constructor(public audio: AudioPlayerService, private authService: AuthService, private readonly gameService: GameService) { }

  ngOnInit(): void {
    this.username = this.authService.getUsername();
  }

  public diplomaLoaded(svg: SVGElement): SVGElement {
    const userNameEl = svg.querySelector('#username');
    if (userNameEl) {
      userNameEl.innerHTML = this.authService.getUsername();
    }
    return svg;
  }
  btnSubmit() {
    this.emailForm.nativeElement.submit();
  }
  sendEmail() {
    this.state = 'sending';
    this.gameService.sendDiploma(this.diplomaEmail).subscribe(() => {
        // console.log('Diploma sent');
        this.closeEndScreen.emit();
    }, (error: any) => {
      this.state = 'input';
        console.error('Diploma not sent');
    });
  }

  Btn_closeEndScreen() {
    this.closeEndScreen.emit();
  }

}
